import { Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../../components/CustomButton";
import CustomCard from "../../../../components/CustomCard/CustomCard";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import {
  getClinicInpatients,
  updateAppointmentStatusById,
  updateCancel,
} from "../../../../redux/reducers/clinicSlice";
import { storeInpatientScreenDetails } from "../../../../redux/reducers/mixedSlice";
import { patchMandateSession } from "../../../../util/mandateSessionStorage";
import InpatientAdmitPatient from "../../../CommonScreens/AdmitPatient/InpatientAdmitPatient";
import BookAnAppointment from "../../../CommonScreens/BookAppointmentment/BookAnAppointment";
import RealschuleReassign from "../../../CommonScreens/RealschuleReassign/RealschuleReassign";

const initSearchValues = {
  Upcoming: "",
  "In Surgery": "",
  Recovery: "",
  Billing: "",
  Completed: "",
};

const Surgery = ({ selectedVet }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [reModVsble, setReModVsble] = useState(false);
  const [reAssign, setReAssign] = useState(false);
  const [followUpModVsble, setFollowUpModVsble] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [cancelModVsble, setCancelModVsble] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [admitModVisible, setAdmitModVisible] = useState(false);
  const [disCofrmModVsble, setDisCofrmModVsble] = useState(false);
  const [sendToRecovery, setSendToRecovery] = useState(false);
  const [searchValues, setSearchValues] = useState(initSearchValues);
  const { inpatients, details: clinicDetails } = useSelector(
    (state) => state?.clinic,
  );

  useEffect(() => {
    onApiCall();
  }, [selectedVet]);

  const onApiCall = () => {
    let url = "?type=all";
    if (selectedVet !== "All") url = `?type=doctor&doctorId=${selectedVet}`;
    dispatch(getClinicInpatients(url)).then((res) => {
      if (res?.payload) {
        if (selectedVet === "All") {
          patchMandateSession({
            inpatients: res?.payload?.data ?? [],
          });
        }
      }
    });
    dispatch(storeInpatientScreenDetails({ selectedVet }));
  };

  const filterAppointmentsByVet = (typ) => {
    return inpatients?.data?.filter(
      (li) =>
        // li?.inpatient &&
        !li?.hospitalization && li?.appointmentStatus === typ,
    );
  };

  const onRescheduleReassign = (li, reassign = false) => {
    setReModVsble(true);
    setReAssign(reassign);
    setSelectedItem(li);
  };

  const handleCancel = (li) => {
    setSelectedItem(li);
    setCancelModVsble(true);
  };

  const handleAdmit = (itm) => {
    setSelectedItem(itm);
    setAdmitModVisible(true);
  };

  const onUpdateStatus = (li, actType) => {
    if (!li?.appointmentId) return;
    let status = "insurgery";
    if (actType === "Send to Surgery") status = "insurgery";
    if (actType === "Send to Recovery") {
      setSelectedItem(li);
      setSendToRecovery(true);
      setAdmitModVisible(true);
      // status = "recovery";
      return;
    }
    if (actType === "Discharge") {
      // status = "finalize";
      setSelectedItem(li);
      setDisCofrmModVsble(true);
      return;
    }
    if (actType === "Check-out") status = "completed";
    dispatch(
      updateAppointmentStatusById({
        appointmentId: li?.appointmentId,
        status,
        successMsg: "Status updated successfully!",
      }),
    ).then((res) => {
      if (res?.payload) {
        // if (status === "completed" && li?.patientId) {
        //   dispatch(dischargePatientId(li?.patientId));
        // }
        onApiCall();
      }
    });
  };

  const onFollowUp = (li) => {
    setSelectedItem(li);
    setFollowUpModVsble(true);
  };

  const navigatePetDetailsScreen = (appointment) => {
    // if (appointment?.appointmentId) {
    //   dispatch(getPetsCompliantSummary(appointment?.appointmentId));
    // } else if (appointment?.petId) {
    //   dispatch(getPetDetailsById(appointment?.petId));
    // }
    navigate(`/clinic-pet-details`, {
      state: { appointment: { appoinment: appointment } },
    });
  };

  const handleChangeCardSearchValue = (value, type) => {
    const reqObj = { ...searchValues, [type]: value };
    setSearchValues(reqObj);
  };

  const renderSection = (
    title,
    data,
    colorClass,
    sectionType,
    checkIn,
    threedots,
  ) => {
    const filteredData = data?.filter((li) => {
      const search = searchValues?.[sectionType]?.toLowerCase();
      if (!search) return true;
      return (
        li?.petName?.toLowerCase()?.includes(search) ||
        li?.userName?.toLowerCase()?.includes(search) ||
        li?.doctorName?.toLowerCase()?.includes(search)
      );
    });

    return (
      <div className="w20Per borderRight">
        <div className="flex-row">
          <div className="p10MinWid99Per ">
            <Typography
              className={`card-head-${colorClass}-color card-head-border-bottom-${colorClass} font-bold fs20`}
            >
              {title} ({data?.length ?? 0})
            </Typography>
            <CustomCard
              list={filteredData ?? []}
              inpatient
              surgery
              sectionType={sectionType}
              onClickResch={(li) => onRescheduleReassign(li, false)}
              onReassign={(li) => onRescheduleReassign(li, true)}
              handleAction={(li, actType) => {
                onUpdateStatus(li, actType);
              }}
              handleCancel={(li) => handleCancel(li)}
              handleCompleted={
                (li) => {}
                // handleCompleted(li)
              }
              onFollowUp={(li) => onFollowUp(li)}
              onClick={(li) => navigatePetDetailsScreen(li)}
              checkIn={checkIn}
              threedots={threedots}
              handleConsult={
                (li) => {}
                //  handleConsult(li)
              }
              handleCheckout={
                (li) => {}
                // handleCheckout(li)
              }
              handleAdmit={(itm) => handleAdmit(itm)}
              searchValue={searchValues[sectionType]}
              onChangeSearchValue={handleChangeCardSearchValue}
              clinicDetails={{ billingMode: clinicDetails?.billingMode }}
            />
          </div>
        </div>
      </div>
    );
  };

  const onCloseModal = () => {
    setReModVsble(false);
    setReAssign(false);
    setSelectedItem(null);
    onApiCall();
  };

  const onCloseCancelModal = () => {
    setCancelModVsble(false);
    setSelectedItem(null);
    setCancelReason("");
  };

  const onConfirmCancel = () => {
    if (!selectedItem?.appointmentId) return;
    dispatch(
      updateCancel({
        appId: selectedItem?.appointmentId,
        reason: cancelReason,
      }),
    ).then((res) => {
      if (res?.payload) {
        onCloseCancelModal();
        onApiCall();
      }
    });
  };

  const onCloseFollowUpMod = () => {
    setFollowUpModVsble(false);
    setSelectedItem(null);
  };

  const onCloseAdmitModal = (val) => {
    if (val === "Api Success") {
      if (sendToRecovery) {
        dispatch(
          updateAppointmentStatusById({
            appointmentId: selectedItem?.appointmentId,
            status: "recovery",
            successMsg: "Status updated successfully!",
          }),
        )?.then((res) => {
          if (res?.payload) onApiCall();
        });
      } else {
        onApiCall();
      }
    }
    setAdmitModVisible(false);
    setSelectedItem(null);
    setSendToRecovery(false);
  };

  const onCloseDischargeMod = () => {
    setDisCofrmModVsble(false);
    setSelectedItem(null);
  };

  const onConfrimDischarge = () => {
    dispatch(
      updateAppointmentStatusById({
        appointmentId: selectedItem?.appointmentId,
        status: "finalize",
        successMsg: "Status updated successfully!",
      }),
    ).then((res) => {
      if (res?.payload) {
        onCloseDischargeMod();
        onApiCall();
      }
    });
  };

  return (
    <>
      <div className="flex-center mt20">
        {renderSection(
          "Upcoming",
          filterAppointmentsByVet("scheduled"),
          "orange",
          "Upcoming",
          true,
          true,
        )}
        {renderSection(
          "In Surgery",
          filterAppointmentsByVet("insurgery"),
          "rose",
          "In Surgery",
          true,
          true,
        )}
        {renderSection(
          "Recovery",
          filterAppointmentsByVet("recovery"),
          "green",
          "Recovery",
          true,
          true,
        )}
        {renderSection(
          "Billing",
          filterAppointmentsByVet("finalize"),
          "yellow",
          "Billing",
          true,
          true,
        )}
        {renderSection(
          "Completed",
          filterAppointmentsByVet("completed"),
          "paleGreen",
          "Completed",
          true,
          true,
        )}
      </div>
      {followUpModVsble ? (
        <BookAnAppointment
          modalVisible={followUpModVsble}
          setBookModVisible={onCloseFollowUpMod}
          selectedPet={{
            petId: selectedItem?.petId,
            petName: selectedItem?.petName,
            petImage: selectedItem?.petImage,
            gender: selectedItem?.gender,
            breed: selectedItem?.breed,
            dob: selectedItem?.dob,
            userName: selectedItem?.userName,
            color: selectedItem?.color,
            weight: selectedItem?.weight,
            userMobile: selectedItem?.userMobile,
            mobile: selectedItem?.mobile,
          }}
          prevAppointmentId={selectedItem?.appointmentId}
        />
      ) : null}
      {reModVsble ? (
        <RealschuleReassign
          modalVisible={reModVsble}
          onCloseModal={onCloseModal}
          selectedPet={{
            petId: selectedItem?.petId,
            petName: selectedItem?.petName,
            petImage: selectedItem?.petImage,
            gender: selectedItem?.gender,
            breed: selectedItem?.breed,
            dob: selectedItem?.dob,
            userName: selectedItem?.userName,
          }}
          isInpatient
          selectedItem={selectedItem}
          reAssign={reAssign}
        />
      ) : null}
      {admitModVisible ? (
        <InpatientAdmitPatient
          modalVisible={admitModVisible}
          onCloseMod={onCloseAdmitModal}
          modalData={selectedItem}
          sendToRecovery={sendToRecovery}
        />
      ) : null}
      <CustomModal
        open={cancelModVsble}
        onClose={onCloseCancelModal}
        header="Cancel"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to cancel the appointment?
        </Typography>
        <div className="ml10 mt15">
          <CustomTextField
            label="Reason for cancellation"
            placeholder="Enter reason for cancellation (optional)"
            multiline
            rows={4}
            value={cancelReason}
            handleChange={(e) => setCancelReason(e.target.value)}
            fullWidth
          />
        </div>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                smallBtn
                onClick={onConfirmCancel}
              />
            </div>
            <div className="ml10">
              <CustomButton
                text="No"
                smallBtn
                onClick={() => {
                  onCloseCancelModal();
                  setCancelReason("");
                }}
              />
            </div>
          </div>
        </Grid>
      </CustomModal>
      <CustomModal
        open={disCofrmModVsble}
        onClose={onCloseDischargeMod}
        header="Discharge Pet"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to Discharge the patient?
        </Typography>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                onClick={onConfrimDischarge}
                smallBtn
              />
            </div>
            <div className="ml10">
              <CustomButton text="No" smallBtn onClick={onCloseDischargeMod} />
            </div>
          </div>
        </Grid>
      </CustomModal>
    </>
  );
};

export default Surgery;
